import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.apiUrl,
  timeout: 30000, // 30 second timeout
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

// Интерцепторы для улучшения обработки ошибок
api.interceptors.response.use(
    response => response.data,
    error => {
      // Улучшаем сообщения об ошибках для пользователя
      if (error.response?.status === 401) {
        error.message = 'Login required';
      } else if (error.response?.status === 403) {
        error.message = 'Insufficient access rights';
      } else if (error.response?.status >= 500) {
        error.message = 'Server error. Please try again later';
      } else if (!error.response) {
        error.message = 'Connection issues with the server';
      } else if (error.response?.data?.error) {
        error.message = error.response.data.error;
      } else if (error.response?.data?.detail) {
        error.message = error.response.data.detail;
      }

      return Promise.reject(error);
    }
);

export default api;
